import * as React from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import TopbarMenuLink from '../../../../theme/pages/_layout/topbar/TopbarMenuLink';
import {DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown} from 'reactstrap';
import {withRouter, RouteComponentProps} from 'react-router-dom';
import {connect} from 'react-redux';
import {ACCESS_TOKEN} from '../../../../utils/constants';
import {setIsAuthenticated} from '../../../../reduxstore/actions/action-creators';
import AppAction from '../../../../reduxstore/actions/action';
import {UserDetails} from '../../../../api/mirana-api';

const Ava = process.env.PUBLIC_URL + '/img/ava.png';

interface TopbarProps {
    userDetails: UserDetails;
    dispatch: (action: AppAction) => (any);
}

const mapStateToProps = (state) => {
    const stateProps = {
        userDetails: state.app.getUserDetails()
    };
    return stateProps;
};

class TopbarProfile extends  React.PureComponent<TopbarProps & RouteComponentProps<any>> {

    public handleLogout = () => {
        localStorage.removeItem(ACCESS_TOKEN);
        this.props.dispatch(setIsAuthenticated(false));
        this.props.history.push('/ingreso');
    };

    public render() {
        const {userDetails} = this.props;
        return (
            <UncontrolledDropdown className='topbar__profile'>
                <DropdownToggle className='topbar__avatar'>
                    <img className='topbar__avatar-img' src={Ava} alt='avatar'/>
                    <p className='topbar__avatar-name'>{userDetails ? userDetails.nombre : ''}</p>
                    <DownIcon className='topbar__avatar-icon'/>
                </DropdownToggle>
                <DropdownMenu className='topbar__menu dropdown__menu'>
                    <DropdownItem onClick={this.handleLogout}>
                        <TopbarMenuLink title='Cerrar Sesión' onClick={this.handleLogout} path='/log_in'/>
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        )
    }
}

export default  withRouter(connect(mapStateToProps)(TopbarProfile));


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar-profile.tsx